import { downgradeComponent } from '@angular/upgrade/static';
import { downgradedAngularModule } from 'src/ajs-app/app';
import { ConditionsOnCustomFieldsComponent } from 'src/app/shared/components/conditions-on-custom-fields/conditions-on-custom-fields.component';
import { DateTimeScheduleModalComponent } from 'src/app/shared/components/date-time-schedule-modal/date-time-schedule-modal.component';
import { MessageContentComponent } from 'src/app/shared/components/message-content/message-content.component';
import { PasswordRequestComponent } from 'src/app/shared/components/password-request/password-request.component';
import { TaskAndMessageActionsMenuComponent } from 'src/app/shared/components/task-and-message-actions-menu/task-and-message-actions-menu.component';

downgradedAngularModule
  .directive('angularConditionsOnCustomFields', downgradeComponent({ component: ConditionsOnCustomFieldsComponent }))
  .directive('angularDateTimeScheduleModal', downgradeComponent({ component: DateTimeScheduleModalComponent }))
  .directive('angularMessageContent', downgradeComponent({ component: MessageContentComponent }))
  .directive('angularTaskAndMessageActionsMenu', downgradeComponent({ component: TaskAndMessageActionsMenuComponent }))
  .directive('angularPasswordRequest', downgradeComponent({ component: PasswordRequestComponent }))

  ;
